module.exports = __webpack_public_path__ + "img/8C.6c1e8ab1.png";